// USER-CODE-ORIGIN: the design-system tile renders OUR DS showcase over the
// PROJECT's own data (design system, components, functions), so it is a
// user-code mount and runs in the opaque user-code frame (userCodeFrame.js).
//
// The DS chrome (swatches / rows / sections) lives in
// workspace/packages/design-system and is handed in by the CALLER (canvas /
// preview) as `dsComponents` + `dsPages`. This keeps @symbo-ls/workspace-shared
// free of any dependency on @symbo-ls/workspace-design-system.
//
// Everything crosses as DATA, so the page is picked HERE: the parent reads
// `dsPages[dsPage]` and mounts that spec directly under `DsScene`. The DS
// package's own `DesignSystemScene` cannot cross — its `children` closes over
// the `dsPages` import, which a bundler renames (`(0, _dsPagesJsDefault
// .default)`) and which does not exist in the frame. A page change is a
// remount over the frame's port (`embedDesignSystem` again with the new
// `dsPage`), not a state write into another realm.

import { mountUserCode } from './userCodeFrame.js'

const dsShellFor = (spec) => ({
  flow: 'column',
  height: '100vh',
  width: '100vw',
  gap: '0',
  overflow: 'hidden',
  DsScene: {
    flex: '1',
    position: 'relative',
    overflow: 'auto',
    ...(spec ? { Page: spec } : {})
  }
})

const pageSpecOf = (dsPages, route) => {
  const active = (dsPages && (dsPages[route] || dsPages['/'])) || null
  if (!active || typeof active !== 'object') return null
  const { key: _dropKey, ...spec } = active
  return spec
}

export async function embedDesignSystem(
  iframeNode,
  data,
  initialState = {},
  dsComponents = {},
  { dsPages = null, dsFrameKit = null, calls = {}, allow = null, onError = null, el = null } = {}
) {
  if (!iframeNode || !data) return null
  const route = (initialState && initialState.dsPage) || '/'
  return mountUserCode(iframeNode, data, dsShellFor(pageSpecOf(dsPages, route)), {
    path: '/',
    // The DS components reach their helpers through el.call; the frame has no
    // parent registry, so the DS package's own frame kit (pure helpers as
    // CODE) rides in, and its editor actions are `calls` (design review D1).
    frameKit: dsFrameKit,
    calls,
    allow,
    onError,
    el,
    logTag: '__ds' + route,
    contextOverrides: {
      pages: undefined,
      app: undefined,
      router: false,
      // The DS bundle under the project's own components: project components
      // still win for any collision (its own tokens / brand overrides).
      components: { ...dsComponents, ...(data.components || {}) },
      state: { ...(data.state || {}), ...initialState, dsReady: true }
    }
  })
}
